import rem from '@/utils/rem'

const Input = ({ label, id, full, maxWidth, icon, ...inputProps }) => {

	const inputStyles = {
		maxWidth: rem(maxWidth)
	}

	return (
		<div className="input-prefix-icon" style={inputStyles}>
			<div className='input-prefix-icon__icon'>{icon}</div>
			<div className='input-prefix-icon__text' id={id} name={id}>
				<input type='text' {...inputProps} />
			</div>
		</div>
	)
}

export default Input
